var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "user-preview" }, [
    _c("ul", { attrs: { id: "result-list" } }, [
      _c("li", [
        _c("section", [
          _c("div", { staticClass: "company-area" }, [
            _c(
              "div",
              { staticClass: "clearfix", staticStyle: { display: "block" } },
              [
                _c(
                  "h2",
                  {
                    staticClass: "company-name fwB",
                    attrs: { "data-test": "company-name" },
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.jobSearchResult.companyName) +
                        "\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass: "limit flr fs11",
                    attrs: { "data-test": "posting-date" },
                  },
                  [
                    _vm._v(
                      "\n              掲載終了予定日 yy/mm/dd\n            "
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c("h3", { staticClass: "fs16 hd-type-02 company-title" }, [
              _c(
                "a",
                {
                  staticClass: "job-title",
                  attrs: { "data-test": "job-title" },
                },
                [_c("span", [_vm._v(_vm._s(_vm.jobSearchResult.jobTitle))])]
              ),
            ]),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "tags" },
              [
                _c("li", [
                  _c("ul", { staticClass: "icon" }, [
                    _c("li", { staticClass: "new" }, [
                      _c("img", {
                        attrs: {
                          "data-test": "new-icon",
                          src:
                            _vm.userOfferImageUrlForPc +
                            "/icon_company_new.png",
                          alt: "新着",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _vm.jobSearchResult.isSimple &&
                    !_vm.jobSearchResult.isOriginalEntryForm
                      ? _c(
                          "li",
                          {
                            staticClass: "simple",
                            attrs: { "data-test": "simple" },
                          },
                          [
                            _c("img", {
                              attrs: {
                                "data-test": "simple-icon",
                                src:
                                  _vm.userOfferImageUrlForPc +
                                  "/icon_company_simple.png",
                                alt: "シンプル",
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("li", { staticClass: "company_interview" }, [
                      _c("img", {
                        attrs: {
                          "data-test": "interview-icon",
                          src:
                            _vm.userCommonImageUrlForPc +
                            "/icon_company_interview.png",
                          alt: "インタビュー",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "company_photo" }, [
                      _c("img", {
                        attrs: {
                          "data-test": "photo-clip-icon",
                          src:
                            _vm.userCommonImageUrlForPc +
                            "/icon_company_photo.png",
                          alt: "フォトクリップ",
                        },
                      }),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c("job-employment-status-pc", {
                  attrs: { "employment-status": _vm.employmentStatus },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("article", { staticClass: "contents-inner" }, [
            _c("div", [
              _c(
                "p",
                {
                  staticClass: "fs15 fwB",
                  attrs: { "data-test": "main-title" },
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.jobSearchResult.mainTitle) +
                      "\n            "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("figure", { staticClass: "premium-image" }, [
              _vm.photoData && _vm.jobSearchResult.isExistsPremiumImage
                ? _c("img", {
                    staticClass: "premium-img",
                    attrs: {
                      id: _vm.photoData.id,
                      src: _vm.getPhotoUrl(_vm.photoData),
                      "data-test": "premium-photo",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.jobSearchResult.isLightPlan &&
              _vm.jobSearchResult.isExistsPremiumImage
                ? _c(
                    "figcaption",
                    {
                      staticClass: "fs11 pt10 main-caption",
                      attrs: { "data-test": "premium-photo-caption" },
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.jobSearchResult.mainCaption) +
                          "\n            "
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "clearfix mt15",
                staticStyle: { display: "block" },
              },
              [
                _c("div", { staticClass: "fll" }, [
                  _c("div", { staticClass: "details clearfix" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: _vm.isLongContentStyle
                          ? "detail-right -long"
                          : "detail-right",
                        attrs: { "data-test": "job-content-outer" },
                      },
                      [
                        _c(
                          "div",
                          {
                            class: _vm.isLongContentStyle
                              ? "two-line"
                              : "three-line",
                            attrs: { "data-test": "job-content-inner" },
                          },
                          [
                            _c("p", [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(_vm.jobSearchResult.catchCopy) +
                                  "\n                    "
                              ),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "details clearfix" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: _vm.isLongContentStyle
                          ? "detail-right -long"
                          : "detail-right",
                        attrs: { "data-test": "offer-required-outer" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "two-line",
                            attrs: { "data-test": "offer-required-inner" },
                          },
                          [
                            _c("p", [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(_vm.jobSearchResult.requiredSkill) +
                                  "\n                    "
                              ),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "details clearfix" }, [
                    _vm._m(3),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: _vm.isLongContentStyle
                          ? "detail-right -long"
                          : "detail-right",
                        attrs: { "data-test": "salary-outer" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "two-line",
                            attrs: { "data-test": "salary-inner" },
                          },
                          [
                            _c("p", [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(_vm.jobSearchResult.salary) +
                                  "\n                    "
                              ),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "details clearfix" }, [
                    _vm._m(4),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: _vm.isLongContentStyle
                          ? "detail-right -long"
                          : "detail-right",
                        attrs: { "data-test": "place-outer" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "two-line",
                            attrs: { "data-test": "place-inner" },
                          },
                          [
                            _c("p", [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(_vm.jobSearchResult.place) +
                                  "\n                    "
                              ),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _vm.photoData &&
                !_vm.jobSearchResult.isLightPlan &&
                !_vm.jobSearchResult.isExistsPremiumImage
                  ? _c("figure", { staticClass: "flr" }, [
                      _c("img", {
                        staticClass: "offer-img-main",
                        attrs: {
                          id: _vm.photoData.id,
                          src: _vm.getPhotoUrl(_vm.photoData),
                          "data-test": "offer-main-image",
                        },
                      }),
                      _vm._v(" "),
                      _c("figcaption", {
                        staticClass: "fs11 pt10 pega-pre-wrap",
                        attrs: { "data-test": "offer-main-image-caption" },
                        domProps: {
                          textContent: _vm._s(_vm.jobSearchResult.mainCaption),
                        },
                      }),
                    ])
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "clearfix mt20",
                staticStyle: { display: "block" },
              },
              [
                _c("job-appeal-point-pc", {
                  attrs: { "is-search-result": true, "pr-codes": _vm.prCodes },
                }),
                _vm._v(" "),
                !_vm.jobSearchResult.isLightPlan && _vm.report.body
                  ? _c("div", { staticClass: "viewpoints" }, [
                      _c("img", {
                        staticClass: "mb5",
                        attrs: {
                          src: _vm.userCommonImageUrlForPc + "/viewpoints.png",
                          alt: "viewpoints",
                        },
                      }),
                      _vm._v(" "),
                      _c("h3", { staticClass: "fs12 fwB mt10" }, [
                        _vm._v(
                          "\n                女の転職！取材レポート\n              "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "fs12 plr10 tl short-viewpoint" },
                        [
                          _c("p", [
                            _vm.report.name
                              ? _c("span", {
                                  staticClass: "fwB",
                                  attrs: { "data-test": "reporter-name" },
                                  domProps: {
                                    textContent: _vm._s(
                                      "取材担当" + _vm.report.name + "より／"
                                    ),
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("span", {
                              attrs: { "data-test": "report" },
                              domProps: {
                                textContent: _vm._s(_vm.report.body),
                              },
                            }),
                          ]),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-type-02 pt25 pb25 btn-set" }, [
            _c("a", { staticClass: "save-button review -mini fwB mr5 fade" }, [
              _c("span", { staticClass: "fs14" }, [
                _c("img", {
                  staticClass: "heart",
                  attrs: {
                    src: _vm.userCommonImageUrlForPc + "/icon_heart.png",
                  },
                }),
                _vm._v("気になる\n            "),
              ]),
            ]),
            _vm._v(" "),
            _vm._m(5),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [_c("span", { staticClass: "fs18" }, [_vm._v("｜")])])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "detail-left" }, [
      _c("h4", [_vm._v("仕事内容")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "detail-left" }, [
      _c("h4", [_vm._v("応募資格")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "detail-left" }, [
      _c("h4", [_vm._v("給与")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "detail-left" }, [
      _c("h4", [_vm._v("勤務地")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "main-color-button -mini fwB ml10 fade" }, [
      _c("span", { staticClass: "fs14" }, [_vm._v("詳細を見る")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }